export const DIMENSIONS = ["warmth", "curiosity", "boundaries", "exitTiming"] as const;

export type Dimension = (typeof DIMENSIONS)[number];
export type Scores = Record<Dimension, number>;

export interface Choice {
  id: string;
  label: string;
  signal: string;
  reply: string;
  coach: string;
  delta: Partial<Scores>;
  nextRoundId: string | null;
}

export interface ConversationRound {
  id: string;
  npcLine: string;
  stageNote: string;
  choices: Choice[];
}

export interface Scenario {
  id: string;
  title: string;
  shortTitle: string;
  number: string;
  location: string;
  time: string;
  cast: string;
  description: string;
  invitation: string;
  accent: string;
  rounds: ConversationRound[];
}

export interface SessionProgress {
  scenarioId: string;
  roundId: string | null;
  scores: Scores;
  completed: boolean;
}
